// Single source of truth for the identity and contact details that appear in
// the SMS program disclosures. A2P 10DLC reviewers check that the brand name in
// the consent language, the sample message, and the campaign registration all
// match, so change BRAND_NAME here and nowhere else.

// The registered legal entity, matching the A2P 10DLC campaign registration.
// Deliberately the full "Inc." form rather than the "LAJ Digital" trade name
// used in marketing copy — reviewers compare this against the registration.
export const BRAND_NAME = 'LAJ Digital Inc.';

// Contact details shown on /terms and /privacy. Carrier reviewers expect at
// least one real, reachable channel. Anything left null is simply not rendered,
// so an unfilled field never ships as placeholder text on the live site.
export const CONTACT_EMAIL = 'info@lajdigital.com';
// TODO(laj): optional — fill these in to list them alongside the email.
export const CONTACT_PHONE = null;
export const MAILING_ADDRESS = null;

// Versioned consent language. The exact string a visitor agreed to is stored
// with their opt-in record, so never edit a released version in place — add a
// new one and point CONSENT_VERSION at it. Otherwise old records would claim
// wording that was never shown.
// v2: BRAND_NAME became the registered entity "LAJ Digital Inc.", which changes
// the consent sentence below, so the version bumps rather than being edited in
// place.
export const CONSENT_VERSION = '2026-08-05.v2';

export const SMS_CONSENT_TEXT = `I agree to receive SMS text messages from ${BRAND_NAME} related to my inquiries, account updates, appointments, and service notifications, per the SMS Terms above. Message and data rates may apply. Message frequency varies. Reply STOP to cancel, HELP for help.`;

export const SAMPLE_MESSAGE = `${BRAND_NAME}: Hi Jane, this is a reminder of your consultation tomorrow at 2:00 PM. Reply STOP to opt out, HELP for help.`;
